












import { Component, Prop, Emit, Vue } from "vue-property-decorator";
@Component
export default class TabComponent extends Vue {
  @Prop()
  width!: string;

  @Prop({
    default: ""
  })
  tabName!: string;

  @Prop({
    default: ""
  })
  parentTabName!: string;

  isActive(): boolean {
    return this.tabName === this.parentTabName;
  }

  @Emit()
  click(event: Element): Element {
    return event;
  }
}
